/**
 * @generated SignedSource<<66e8701c2bfd0f20c2c3ee43e36ab9a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_projectResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FiltersMenu_project">;
  readonly " $fragmentType": "topBar_issueNavigator_projectResult";
};
export type topBar_issueNavigator_projectResult$key = {
  readonly " $data"?: topBar_issueNavigator_projectResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_projectResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_projectResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FiltersMenu_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5594f3f44e3a12b26314cdb1292648f2";

export default node;
